import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const logOutAction = {
    ...operations,
    ...selectors,
};

export {
    logOutAction,
};
export default {
    [namespace]: reducer,
};
